import React from 'react';
import {
  Divider,
} from 'antd';
import { GeneralFilter } from '../Filters';
import { ShowAppliedFilter } from '../Filters/ShowAppliedFilter';
import PageWithTopbar from '../PageWithTopbar';
import WeekDayPicker from '../WeekDayPicker';
import {
  Label,
} from './styles';

const FilterBar = ({
  weekStart,
  weekDaySelect,
  globalFilters,
  globalFilterApplied,
  kpiFilterApplied,
  onClickToChangeWeekDaySelect,
  onClickToChangeFilter,
  onClickToToggleFilterView,
  filterDisabled,
  weekdayPickerDisabled,
  persistParams,
  title,
}) => (
  <PageWithTopbar
    bg="greyscale.4"
    leftSpan={10}
    leftComponent={(
            <>
              <GeneralFilter
                filterObj={globalFilters}
                onClickToApplyFilter={onClickToChangeFilter}
                onClickToToggleFilterView={onClickToToggleFilterView}
                globalFilterApplied={globalFilterApplied}
                kpiFilterApplied={kpiFilterApplied}
                hideView={persistParams.hideFilterView}
                disabled={filterDisabled}
                ml={6}
              />
              <Divider type="vertical" />
              <ShowAppliedFilter
                globalFilterApplied={globalFilterApplied}
                kpiFilterApplied={kpiFilterApplied}
                filterObj={globalFilters}
                hideView={persistParams.hideFilterView}
              />
            </>
          )}
    midSpan={4}
    midComponent={<Label py="2">{title}</Label>}
    rightSpan={10}
    rightComponent={(
      <WeekDayPicker
        startDate={weekStart}
        selection={weekDaySelect}
        onChange={e => onClickToChangeWeekDaySelect(e.target.value)}
        disabled={weekdayPickerDisabled}
      />
          )}
  />
);


export default FilterBar;
